import { render, staticRenderFns } from "./RegistrationPanel.vue?vue&type=template&id=6db877f1&scoped=true&"
import script from "./RegistrationPanel.vue?vue&type=script&lang=js&"
export * from "./RegistrationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db877f1",
  null
  
)

export default component.exports